import {Fill} from "nano-slots";
import React, {ReactNode} from "react";
import {Chip, ChipProps, FormControl, MenuItem, Select, Stack} from "@mui/material";
import {GlobalState} from "../../global/GlobalState";
import {EnvironmentStage, environmentStages} from "../../data/EnvironmentStage";
import {translateFunction} from "../../localization/TranslationService";
import {Environment} from "../../global/Environment";

const translate = translateFunction();

const tagsSlotName = "tags";

export function HeaderSlot(props: { children: ReactNode }) {
	return <Fill name={tagsSlotName}>
		<Stack
			direction={"row"}
			spacing={2}
			justifyContent={"flex-end"}
		>
			{props.children}
		</Stack>
	</Fill>;
}

export function CurrentStageDisplay() {
	return StageDisplay({targetStage: Environment.stage});
}

export function StageDisplay(props: {
	targetStage: EnvironmentStage;
}) {
	return <FormControl>
		<Select
			style={{width: "150px"}}
			variant={"standard"}
			value={props.targetStage}
			disabled
		>
			<MenuItem key={props.targetStage} value={props.targetStage}>
				<StageChip stage={props.targetStage} />
			</MenuItem>
		</Select>
	</FormControl>;
}

export function StageSwitch({
	targetStage,
	defaultTargetStage,
}: {
	targetStage?: EnvironmentStage | null;
	defaultTargetStage: EnvironmentStage;
}) {
	if (targetStage !== undefined && targetStage !== GlobalState.targetStage) {
		GlobalState.targetStage = targetStage;
	}
	
	const value = targetStage === undefined ? GlobalState.targetStage : targetStage;
	
	return <FormControl>
		<Select
			style={{width: "150px"}}
			variant={"standard"}
			value={value ?? "default"}
			onChange={event => GlobalState.targetStage = event.target.value === "default" ? null : event.target.value as EnvironmentStage}
		>
			<MenuItem key={"null"} value={"default"}>
				<Chip label={translate("Default") + " (" + defaultTargetStage + ")"} color={stageColor(defaultTargetStage)} />
			</MenuItem>
			{environmentStages.map(it => <MenuItem key={it} value={it}>
				<StageChip stage={it} />
			</MenuItem>)}
		</Select>
	</FormControl>;
}

export function CurrentStageChip(props: ChipProps) {
	return StageChip({...props, stage: Environment.stage});
}

export interface StageChipProps {
	readonly stage: EnvironmentStage;
}
export function StageChip(props: StageChipProps & ChipProps) {
	return <Chip {...props} label={translate(props.stage)} color={stageColor(props.stage)}/>;
}

function stageColor(stage: EnvironmentStage) {
	if (stage === "dev")
		return "success";
	if (stage === "acc")
		return "warning";
	if (stage === "prod")
		return "error";
}

export function Footer() {
	return <></>;
}

